import React from "react";
import Plot from "react-plotly.js";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const PlotlyGraph = ({ plotData, rearrangeReferences }) => {
  if (!plotData || !Array.isArray(plotData) || plotData.length === 0) {
    return null;
  }


  const getRandomColor = () =>
    "#" + Math.floor(Math.random() * 16777215).toString(16);

 

  return (
    <div className="grid grid-cols-1 gap-6">
      {plotData.map((plot, idx) => (
        <div key={idx} className="plot-card border p-6 rounded-lg bg-white shadow-sm">
          <div className="mb-4">
            <h4 className="text-lg font-semibold text-gray-800 mb-2">{plot.title}</h4>
            <div className="text-sm text-gray-600 leading-relaxed">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
              >
                {rearrangeReferences(plot.context || 'No summary available')}
              </ReactMarkdown>
            </div>
          </div>
          
          <div className="bg-gray-100 rounded-lg p-2 ">
            <Plot
              data={[
                {
                  type: plot.chart_type,
                  x: plot.data.x_vals,
                  y: plot.data.y_vals,
                  text: plot.data.y_vals.map(val => `${val}`),
                  textposition: 'outside',
                  marker: {
                    color: ["#bb1ccc", "#0000a0", "#C75D2C", "#FF9B00", "#EBE389","#8AA624"],
                    line: {
                      color: 'rgba(0,0,0,0.1)',
                      width: 1
                    }
                  },
                  hovertemplate: '<b>%{x} is </b>%{y}<extra></extra>',
                },
              ]}
              layout={{
                title: {
                  text: '',
                  font: { size: 16, family: 'Arial, sans-serif' }
                },
                xaxis: { 
                  title: {
                    // text: plot.data.x_name,
                    font: { size: 12, family: 'Arial, sans-serif' }
                  },
                  tickangle: -45,
                  tickfont: { size: 10 },
                  automargin: true
                },
                yaxis: { 
                  title: {
                    // text: plot.data.y_name,
                    font: { size: 12, family: 'Arial, sans-serif' }
                  },
                  tickfont: { size: 10 }
                },
                margin: {
                  l: 80,
                  r: 40,
                  t: 40,
                  b: 120
                },
                autosize: true,
                responsive: true,
                showlegend: false,
                plot_bgcolor: 'rgba(0,0,0,0)',
                paper_bgcolor: 'rgba(0,0,0,0)',
                font: {
                  family: 'Arial, sans-serif'
                }
              }}
              useResizeHandler={true}
              style={{ width: "100%", minHeight: "450px" }}
              config={{
                displaylogo: false,
                modeBarButtonsToRemove: [
                  'lasso2d', 
                  'select2d', 
                  'hoverClosestCartesian', 
                  'hoverCompareCartesian',
                  'toggleSpikelines'
                ],
                responsive: true
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlotlyGraph;